<div class="navbar-wrapper">
  <nav class="navbar navbar-static-top" style="padding: 0rem 0.5rem !important;">
    <div class="d-lg-flex flex-wrap flex-row justify-content-between container">
      <div class="col-lg safescript-gutters">
        <img src="/assets/images/Logo.png" alt="logo" height="45px" />
      </div>
    </div>
  </nav>
</div>
<div class="container-fluid">
  <div style="background-color:#BC5915; min-height: 290px;">
    <div class="d-lg-flex flex-wrap flex-row container pt-2">
      <div class="col-lg">

      </div>
      <div class="col-lg-6 safescript-gutters">
        <div class="d-flex justify-content-end">
          <a class="safescript-Link pe-2" (click)="support()">Help</a>
          <div class="vline pe-2"></div>
          <a class="safescript-Link" (click)="contactUs()">Contact us</a>
        </div>
      </div>
    </div>
    <div class="d-lg-flex flex-wrap flex-row container pt-3">
      <div class="col-lg-6 safescript-gutters">
        <p style="color: white;" class="pt-3">
          NTScript is a clinical tool providing real-time monitored medicines prescription information for prescribers
          and pharmacists to support safer clinical decision-making.
        </p>
      </div>
      <div class="col-lg-6 safescript-gutters">
        <img src="/assets/images/Computer-Image.png" alt="logo" height="170px" class="laptopImage" />
      </div>
    </div>
  </div>
  <div class="register-container container position-relative">
    <div class="d-lg-flex flex-wrap flex-row">
      <div class="col-lg-4 safescript-gutters">
        <div class="shadebox justify-content-start">
          <div class="d-lg-flex register-container-header">
            <h4>Health Practitioner Registration</h4>
          </div>
          <div class="d-lg-flex register-container-info">
            <p style="font-style: italic;">
              <span class="wrapText">Eligible AHPRA-registered prescribers and pharmacists can sign-up for NTScript
                access here.</span>
            </p>
          </div>
          <div class="d-lg-flex justify-content-center">
            <button class="btn btn-lg btn-primary safescript-button" type="button"
              (click)="registrationLogin()">Register</button>
          </div>
        </div>
      </div>

      <div class="col-lg-4 safescript-gutters">
        <div class="shadebox justify-content-start">
          <div class="d-lg-flex register-container-header">
            <h4>Health Practitioner Training </h4>
          </div>
          <div class="d-lg-flex register-container-info">
            <p style="font-style: italic;">
              <span class="wrapText"> Health practitioners can access accredited CPD training and resources here.</span>
            </p>
          </div>
          <div class="d-lg-flex justify-content-center">
            <button class="btn btn-lg btn-primary safescript-button safescript-purple" type="button"
              (click)="training()">Training</button>
          </div>
        </div>
      </div>

      <div class="col-lg-4 safescript-gutters">
        <div class="shadebox justify-content-start">
          <div class="d-lg-flex register-container-header">
            <h4>Health Practitioner Login </h4>
          </div>
          <div class="d-lg-flex register-container-info">
            <p style="font-style: italic;">
              <span>Already registered? </span>
              <br />
              <span>
                Log in to access NTScript here.
              </span>
            </p>
          </div>
          <div class="d-lg-flex justify-content-center">
            <button class="btn btn-lg btn-primary safescript-button safescript-purple" type="button"
              (click)="hpLogin()">Login</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="information-container container pt-4">
    <div class="d-lg-flex flex-wrap">
      <div class="col-lg-12 p-2">
        <div class="d-lg-flex justify-content-center">
          <h4> I am a patient </h4>
        </div>
        <div class="d-lg-flex justify-content-center">
          <p style="color: #212121;">
            <span class="wrapText">For information for patients relating to NTScript, click <a class="qscript-Link pe-2"
                (click)="ntscriptWebsite()">here.</a>
            </span>
            <br>
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="support-container pt-3">
    <div class="d-lg-flex flex-wrap container">
      <div class="col-lg-4 supportDiv p-2 justify-content-start">
        <div>
          <i class="fa fa-user-headset faRed">
          </i>
        </div>
        <div class="d-lg-flex pt-1">
          <h4>
            Technical support and general enquiries
          </h4>
        </div>
        <div class="d-lg-flex">
          <p style="color: #212121;">
            <span class="wrapText">08 8922 7341
            </span>
            <br>
          </p>
        </div>
      </div>
      <div class="col-lg-4 supportDiv p-2 justify-content-start">
        <div>
          <i class="fa fa-desktop faRed">
          </i>
        </div>
        <div class="d-lg-flex pt-1">
          <h4> NTScript website </h4>
        </div>
        <div class="d-lg-flex">
          <p style="color: #212121;">
            <span class="wrapText">
              For more information on NTScript, click <a class="qscript-Link" (click)="ntscriptWebsite()">here.</a>
            </span>
            <br>
          </p>
        </div>
      </div>
      <div class="col-lg-4 supportDiv p-2 justify-content-start">
        <div>
          <i class="fa fa-wrench faRed">
          </i>
        </div>
        <div class="d-lg-flex pt-1">
          <h4>
            Planned maintenance and updates
          </h4>
        </div>
        <div class="d-lg-flex">
          <app-outtage-message *ngIf="config" [outageText]="config.maintenance"></app-outtage-message>
        </div>
      </div>
    </div>
  </div>
</div>
<footer class="footer-box">
  <div class="container text-center">
    <div class="d-lg-flex flex-row">
      <div class="col-lg-12">
        <div class="d-lg-flex">
          <div class="col">
            <a class="safescript-Link" (click)="support()">Help</a>
          </div>
          <div class="col">
            <a class="safescript-Link" (click)="accessibility()">Accessibility</a>
          </div>
          <div class="col">
            <a class="safescript-Link" (click)="copyright()">Copyright</a>
          </div>
          <div class="col">
            <a class="safescript-Link" (click)="disclaimer()">Disclaimer</a>
          </div>
          <div class="col">
            <a class="safescript-Link" (click)="privacy()">Privacy</a>
          </div>
        </div>
      </div>
    </div>

    <div class="d-lg-flex justify-content-center pt-3">
      <div class="col-lg-10">
        <span>NTScript is managed and authorised by the Department of Health, Northern Territory Government of Australia.
        </span>
      </div>
    </div>

    <div class="d-lg-flex justify-content-center">
      <div class="col-lg-6">
        <p style="font-size:xx-small">&copy;{{year}}  Northern Territory Government of Australia
        </p>
      </div>
    </div>
    
  </div>
</footer>